<sis-cur-flow-state-badge-dynamic
        [flowState]="courseUnitRealisation?.flowState"
        [resolvedFlowState]="courseUnitRealisation | resolvedFlowState"
        [publishDate]="hidePublishDate ? null : courseUnitRealisation?.publishDate"
        data-cy="flow-state-label'">
</sis-cur-flow-state-badge-dynamic>
